'use strict';

import layout from "../ui/layout";
import analytics from '../utils/analytics';
import tagManager from '../utils/tag-manager';

const classNames = {
    videoPlayer: 'video-player',
    videoSlide: 'video-slide',
    video: 'video'
};

let players = {};
let playerCount = 0;
let setIntervalForYT;

let tracking = {
    track: ($container) => {
        let eventCategory = $($container).data('ga-tracking-category');
        let eventAction = $($container).data('ga-tracking-action');
        let eventLabel = tagManager.getMakeAndModelName();

        if (eventCategory !== '' && eventAction !== '' && eventLabel !== '') {
            analytics.trackEvent(eventCategory, eventAction, eventLabel, null, true);
        }
    }
};

let events = {
    onPlayerStateChange: (event, $container) => {
        if (event.data === window.YT.PlayerState.PLAYING) {
            tracking.track($container);
        }
    }
};

const createPlayer = (playerId, $container) => {
		window.YT.ready(function () {
			players[playerId] = new window.YT.Player(playerId, {
				events: {
					'onStateChange': (event) => {
						events.onPlayerStateChange(event, $container);
					}
				}
			});
		});

		tracking.track($container);

		// broadcast the video iframe has been injected.
		// components like full size gallery can then do further actions like resizing.
		$(document).trigger('video.injected');
}

let container = {
    replaceContentsWithVideoIFrame: ($container, autoplay) => {
        let videoUrl = $($container).data('video-url');
        let playerId = 'player' + playerCount++;
        let $videoFrame = video.buildIFrame(videoUrl, autoplay, playerId);

        $($container).empty().append($videoFrame);

		if (window.YT) {
			createPlayer(playerId, $container);
		} else {
			setIntervalForYT = setInterval(function () {
				if (window.YT) {
					createPlayer(playerId, $container);
					clearInterval(setIntervalForYT);
				}
			}, 2000);
		}
    }
};

let video = {
    addUrlParameters: (autoplay) => {
        let parameters = {};

        if (autoplay) {
            parameters['autoplay'] = 1;
        }

        parameters['enablejsapi'] = 1;

        return parameters;
    },

    buildIFrame: (videoUrl, autoplay, playerId) => {
        let parameters = video.addUrlParameters(autoplay);

        let srcUrl = Object.keys(parameters).length > 0
            ? `${videoUrl}?${$.param(parameters)}`
            : videoUrl;

        let $frame = $('<iframe>');
        $frame.addClass('video-player__video');
        $frame.attr('id', playerId);
        $frame.attr('src', srcUrl);
        $frame.attr('allow', 'accelerometer;autoplay;encrypted-media;gyroscope;picture-in-picture');
        $frame.attr('allowfullscreen', '');
        $frame.attr('frameborder', '0');

        return $frame;
    }
};

export default {
    init: () => {
        let $videoContainers = $('.video-player__container[data-video-url]');
        if (layout.isIOS()) {
            // No autoplay on IOS - load the video now to avoid extra click.
            for (let i = 0; i < $videoContainers.length; i++) {
                container.replaceContentsWithVideoIFrame($videoContainers[i], false);
            }
        } else {
            // Non-iOS can load the video and autoplay when preview is clicked.
            for (let i = 0; i < $videoContainers.length; i++) {
                $($videoContainers[i]).on('click.video', (videoContainer) => {
                    container.replaceContentsWithVideoIFrame(videoContainer.currentTarget, true);
                });
            }
        }
    },

    resizeVideo: (width, height) => {
        let $videoIFrame = $.findByBem(classNames.videoPlayer, classNames.video);
        $videoIFrame.css({
            height: height + 'px',
            width: width + 'px'
        });
    },

    stopVideo: (id) => {
        let player = players[id];
        if (player) {
            player.stopVideo();
        }
    }
}